import { Direction } from "@angular/cdk/bidi";
import { Component, Input } from "@angular/core";

import { InputBoolean, InputNumber } from "ng-zorro-antd/core/util";
import { ɵNzSliderTrackComponent as NzSliderTrackComponent } from "ng-zorro-antd/slider";

@Component({
  selector: "ui-slider-track",
  exportAs: "uiSliderTrack",
  templateUrl: "track.component.html",
})
export class UiSliderTrackComponent extends NzSliderTrackComponent {
  @Input("uiOffset")
  @InputNumber()
  public offset = 0;
  @Input("uiReverse")
  @InputBoolean()
  public reverse = false;
  @Input("uiDir")
  public dir: Direction = "ltr";
  @Input("uiLength")
  @InputNumber()
  public length = 0;
  @Input("uiVertical")
  @InputBoolean()
  public vertical = false;
  @Input("uiIncluded")
  @InputBoolean()
  public included = false;
}
